import { ListItemText } from "@mui/material";
import * as React from "react";
import { LocationListItemType } from "./ListItemLocation.types";
import {
    AvatarListItemDefault,
    AvatarStyled,
    ListItemAvatarContainer,
    ListItemButtonContainer,
    ListItemTextHeadline,
    ListItemTextSubline,
} from "./ListItemLocation.styles";
import { getGroupTypeIcon } from "../../Group/GroupType";
import { SearchItemGroupClickArgType } from "../SearchTextField.types";
import { useMobile } from "../../../../Infrastructure/Hooks/useMobile";

export default function (props: LocationListItemType) {
    const { location, onItemClick } = props;

    const icon = location.icon
        ? location.icon
        : getGroupTypeIcon(location.type);

    const baseAvatarOpts = {};

    let extraAvatarOpts;

    if (typeof icon === "string") {
        extraAvatarOpts = {
            src: icon,
        };
    } else {
        extraAvatarOpts = {
            children: icon,
        };
    }

    const avatarOpts = {
        ...baseAvatarOpts,
        ...extraAvatarOpts,
    };

    const args: SearchItemGroupClickArgType = {
        location: location,
    };

    const { isMobile } = useMobile();

    return (
        <ListItemButtonContainer
            onClick={() => onItemClick(args)}
            disableRipple={isMobile}
            showHover={!isMobile}
        >
            <ListItemAvatarContainer>
                {typeof icon === "string" ? (
                    <AvatarStyled {...avatarOpts} />
                ) : (
                    <AvatarListItemDefault {...avatarOpts} />
                )}
            </ListItemAvatarContainer>
            <ListItemText>
                <ListItemTextHeadline>
                    {location.headline && location.headline.length > 0
                        ? location.headline
                        : "[not set]"}
                </ListItemTextHeadline>
                <ListItemTextSubline>
                    {location.description && location.description.length > 0
                        ? location.description
                        : "[not set]"}
                </ListItemTextSubline>
            </ListItemText>
        </ListItemButtonContainer>
    );
}
